var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"col":""}},[_c('CCard',[_c('CCardHeader',[_c('strong',[_vm._v(" Modulo Videoconferencia")])]),_c('CCardBody')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }